import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "modal-jwt-expired",
  class: "modal"
}
const _hoisted_2 = { class: "modal__content" }
const _hoisted_3 = { class: "p-5 text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-3xl mt-5" }, "Oops...", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 mt-2" }, " Session Anda telah habis, silahkan login kembali.! ", -1)
const _hoisted_6 = { class: "px-5 pb-8 text-center" }
const _hoisted_7 = {
  id: "modal-something-wrong",
  class: "modal"
}
const _hoisted_8 = { class: "modal__content" }
const _hoisted_9 = { class: "p-5 text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-3xl mt-5" }, "Oops...", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 mt-2" }, " Sepertinya ada yang salah, silahkan login kembali.! ", -1)
const _hoisted_12 = { class: "px-5 pb-8 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_xCircleIcon = _resolveComponent("xCircleIcon")!
  const _component_MsgHandler = _resolveComponent("MsgHandler")!
  const _component_PopupConfirmation = _resolveComponent("PopupConfirmation")!
  const _component_PopupStatus = _resolveComponent("PopupStatus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_LoadingScreen),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_xCircleIcon, { class: "w-16 h-16 text-theme-6 mx-auto mt-3" }),
          _hoisted_4,
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            "data-dismiss": "modal",
            class: "button w-24 bg-theme-1 text-white",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
          }, " Ok ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_xCircleIcon, { class: "w-16 h-16 text-theme-6 mx-auto mt-3" }),
          _hoisted_10,
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "button",
            "data-dismiss": "modal",
            class: "button w-24 bg-theme-1 text-white",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
          }, " Ok ")
        ])
      ])
    ]),
    _createVNode(_component_MsgHandler),
    _createVNode(_component_PopupConfirmation),
    _createVNode(_component_PopupStatus)
  ], 64))
}